/** @flow */
import Wizard from './Wizard';

export default Wizard;
export {Wizard};
